angular.module( 'acme.view.application.partners.orders', [
  'ui.router',
  'ui.bootstrap',
  'acme.view.application.partners.orders.controllers',
  'acme.view.application.partners.orders.list',
  'acme.view.application.partners.orders.detail'
])

.config(function config( $stateProvider ) {

  // Create both abstract view and template view.
  // Abstract Views are enabled by default
  var partnersOrders = {
        name: 'application.partners.orders',
        url: '/orders',
        abstract: true,
        views: {
          "subview-main": {
            controller: 'PartnersOrdersController',
            templateUrl: 'views/application/views/partners/orders/orders.tpl.html'
          }
        },
        data: {
          pageTitle: 'Organization Orders',
          permissions: ['ACCT_ORDERS_VIEW']
        }
      };

    $stateProvider
      .state(partnersOrders);
});
